/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardAntiFraudConfigResponse
 */
export interface LeaderboardAntiFraudConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    minEventsToRank: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    maxEventsPerPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    maxEventsPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    anomalyThresholdMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    anomalySigmaThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    autoQuarantine: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    enableAnomalyDetection: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardAntiFraudConfigResponse
     */
    requireActiveMatch?: boolean;
}

/**
 * Check if a given object implements the LeaderboardAntiFraudConfigResponse interface.
 */
export function instanceOfLeaderboardAntiFraudConfigResponse(value: object): value is LeaderboardAntiFraudConfigResponse {
    if (!('minEventsToRank' in value) || value['minEventsToRank'] === undefined) return false;
    if (!('autoQuarantine' in value) || value['autoQuarantine'] === undefined) return false;
    if (!('enableAnomalyDetection' in value) || value['enableAnomalyDetection'] === undefined) return false;
    return true;
}

export function LeaderboardAntiFraudConfigResponseFromJSON(json: any): LeaderboardAntiFraudConfigResponse {
    return LeaderboardAntiFraudConfigResponseFromJSONTyped(json, false);
}

export function LeaderboardAntiFraudConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardAntiFraudConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'minEventsToRank': json['minEventsToRank'],
        'maxEventsPerPeriod': json['maxEventsPerPeriod'] == null ? undefined : json['maxEventsPerPeriod'],
        'maxEventsPerHour': json['maxEventsPerHour'] == null ? undefined : json['maxEventsPerHour'],
        'anomalyThresholdMultiplier': json['anomalyThresholdMultiplier'] == null ? undefined : json['anomalyThresholdMultiplier'],
        'anomalySigmaThreshold': json['anomalySigmaThreshold'] == null ? undefined : json['anomalySigmaThreshold'],
        'autoQuarantine': json['autoQuarantine'],
        'enableAnomalyDetection': json['enableAnomalyDetection'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
    };
}

export function LeaderboardAntiFraudConfigResponseToJSON(json: any): LeaderboardAntiFraudConfigResponse {
    return LeaderboardAntiFraudConfigResponseToJSONTyped(json, false);
}

export function LeaderboardAntiFraudConfigResponseToJSONTyped(value?: LeaderboardAntiFraudConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minEventsToRank': value['minEventsToRank'],
        'maxEventsPerPeriod': value['maxEventsPerPeriod'],
        'maxEventsPerHour': value['maxEventsPerHour'],
        'anomalyThresholdMultiplier': value['anomalyThresholdMultiplier'],
        'anomalySigmaThreshold': value['anomalySigmaThreshold'],
        'autoQuarantine': value['autoQuarantine'],
        'enableAnomalyDetection': value['enableAnomalyDetection'],
        'requireActiveMatch': value['requireActiveMatch'],
    };
}

